import { useContext } from 'react';
import { SearchParamsContext } from '../providers/searchParams.provider';

export const useSearchParams = () => {
  const context = useContext(SearchParamsContext);
  if (!context) throw new Error('useSearchParams debe ser utilizado dentro de un SearchParamsProvider');
  return context;
};
